/* eslint-disable comma-dangle */
/* eslint-disable quotes */

import { LlmMockApp } from '@websolutespa/bom-mixer-llm';
import { theme } from './theme';

export const app: LlmMockApp = {
  "mode": "site",
  "contents": {
    "logo": {
      "id": "681c5d6e6d77017845c30379",
      "filename": "efg_logo.jpg",
      "mimeType": "image/jpeg",
      "filesize": 35013,
      "width": 1080,
      "height": 1080,
      "focalX": 50,
      "focalY": 50,
      "createdAt": "2025-05-08T07:29:50.560Z",
      "updatedAt": "2025-05-08T07:29:50.560Z",
      "url": "https://platform-ai-dev.ws-deploy-01.wslabs.it/media/efg_logo.jpg",
      "type": "image"
    },
    "additionalLogos": [],
    "collapsedWelcomeText": "👋 Welcome!",
    "collapsedWelcomeTextHover": "How can I help you today?",
    "extendedWelcomeText": "Welcome!<br/> How can I help you today?",
    "disclaimerFooter": false,
    "promptPlaceholder": "Type your question...",
    "sampleInputTexts": [
      { "id": "expenses", "sampleInputText": "💰 Expenses" },
      { "id": "faqs", "sampleInputText": "🙋‍♂️ FAQs" },
      { "id": "onboard-help", "sampleInputText": "🤔 Onboard help?" }
    ],
    "layoutBuilder": [],
    "headerCtas": [],
    "disableSpeechRecognition": false,
    "disableSpeechSynthesis": false,
    "enableUpload": true,
    "enableFeedback": true,
    "customTheme": theme,
  }
};
